import React from 'react';

const Footer = () => {
  const scrollToSection = (e, id) => {
    e.preventDefault();
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
  };

  return (
    <footer className="bg-[#1B4D3E] text-[#F5F0EB] py-16 px-6 md:px-12">
      <div className="max-w-7xl mx-auto">
        <div className="grid grid-cols-1 md:grid-cols-2 gap-12">
          {/* Logo and Nav */}
          <div>
            <h2 
              className="text-2xl font-bold mb-6"
              style={{fontFamily: 'Space Grotesk, sans-serif'}}
            >
              Super Boring Company
            </h2>
            <nav className="flex flex-wrap gap-4 text-sm">
              {[
                { label: 'Our Brands', id: 'our-brands' },
                { label: 'Our Thesis', id: 'our-thesis' },
                { label: 'What We Buy', id: 'what-we-buy' },
                { label: 'Our Process', id: 'our-process' },
                { label: 'FAQs', id: 'faqs' },
                { label: 'Contact', id: 'contact' }
              ].map((item) => (
                <a
                  key={item.id}
                  href={`#${item.id}`}
                  onClick={(e) => scrollToSection(e, item.id)}
                  className="text-[#E8E2DB] hover:text-white transition-colors"
                >
                  {item.label}
                </a>
              ))}
            </nav>
          </div>

          {/* Copyright */}
          <div className="flex items-end justify-start md:justify-end">
            <p className="text-sm text-[#E8E2DB]">
              © 2025 Super Boring Company
            </p>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;